import React from "react";
import InlineSVG from "svg-inline-react";

const LOGO = require("svg-inline-loader?classPrefix=__svg__&idPrefix!images/new-logo.svg");
const ICON = require("svg-inline-loader?classPrefix=__svg__&idPrefix!images/new-icon.svg");
const LOGO_WHITE = require("svg-inline-loader?classPrefix=__svg__&idPrefix!images/new-logo-white.svg");
const ICON_WHITE = require("svg-inline-loader?classPrefix=__svg__&idPrefix!images/new-icon-white.svg");

const StLogo = ({ black = false, white = !black, icon = false, ...props }) => {
  let src;
  if (icon) {
    src = white ? ICON_WHITE : ICON;
  } else {
    src = white ? LOGO_WHITE : LOGO;
  }

  return <InlineSVG {...props} src={src} />;
};

export default StLogo;



// WEBPACK FOOTER //
// ./src/lib/components/StLogo.jsx